import { useMemo } from 'react';
import { T } from '~/components/I18n';
import { useOpenDay } from '~/components/Timer/OpenDay/OpenDay.hooks';

export type OpenDayProps = { openAt: Date; className?: string };

export const OpenDay = ({ openAt, className }: OpenDayProps) => {
  const { day, hours, minutes } = useOpenDay(openAt);
  const upcomingText = useMemo(() => {
    switch (day) {
      case 'Today':
        return (
          <T name="citizen_home_b2c_upcoming_time_in24" options={{ time: `${hours}:${minutes}` }} />
        );
      case 'Tomorrow':
        return (
          <T name="citizen_home_b2c_upcoming_time_in48" options={{ time: `${hours}:${minutes}` }} />
        );
      default:
        return (
          <T
            name="citizen_home_b2c_upcoming_time_more48"
            options={{ dateTime: `${day} ${hours}:${minutes}` }}
          />
        );
    }
  }, [day, hours, minutes]);
  return <div className={className}>{upcomingText}</div>;
};
